import { useEffect, useRef } from 'react'

import { NodeEventPlugin } from '@lexical/react/LexicalNodeEventPlugin'
import { $insertNodes, COMMAND_PRIORITY_EDITOR } from 'lexical'

import { useEditor } from '../../hooks/useEditor'
import { useMutationListener } from '../../hooks/useMutationListener'
import { $createEmojiNode, EmojiNode } from '../../nodes/EmojiNode'
import { EmojiPicker } from '../../ui/EmojiPicker'
import { EmojiPickerRef } from '../../ui/EmojiPicker/interface'

import { INSERT_EMOJI_COMMAND } from './commands'

export const EmojiPlugin = () => {
  const editor = useEditor()
  const pickerRef = useRef<EmojiPickerRef>(null)

  useEffect(() => {
    if (!editor.hasNode(EmojiNode)) {
      throw new Error('EmojiPlugin: EmojiNode not registered on editor')
    }
    return editor.registerCommand(
      INSERT_EMOJI_COMMAND,
      payload => {
        const emojiNode = $createEmojiNode(payload.emoji)
        $insertNodes([emojiNode])
        return true
      },
      COMMAND_PRIORITY_EDITOR
    )
  }, [editor])

  // 节点被移除时关闭交互组件
  useMutationListener(EmojiNode, 'destroyed', nodeKey => {
    pickerRef.current?.close(nodeKey)
  })

  return (
    <>
      <NodeEventPlugin
        eventType='click'
        nodeType={EmojiNode}
        eventListener={(_, __, nodeKey) => {
          pickerRef.current?.open(nodeKey)
        }}
      />
      <EmojiPicker ref={pickerRef} />
    </>
  )
}
